// Query-key factory for the collection staging-review reads. The main queue
// (CollectionStagingQueuePage) keys its infinite query under ["collection-staging", …]
// and every staging mutation invalidates that prefix, so scoped reads (e.g. the
// per-broker tab) live under the SAME prefix to ride those invalidations.
export const collectionStagingKeys = {
  all: ["collection-staging"] as const,
  byOwner: (ownerEntityType: string, ownerEntityId: string) =>
    ["collection-staging", "by-owner", ownerEntityType, ownerEntityId] as const,
  // Portal-absorption spine — per-portal-account scoping. Living under the
  // same "collection-staging" prefix means every staging mutation's prefix
  // invalidation refreshes these too (review a row -> the account's tab AND
  // its needs-attention badge update).
  byAccount: (portalUserId: string) =>
    ["collection-staging", "by-account", portalUserId] as const,
  accountSummary: (portalUserId: string) =>
    ["collection-staging", "account-summary", portalUserId] as const,
  // The review panel's per-submission detail read. Deliberately NOT under the
  // "collection-staging" prefix (its historical key); review mutations
  // invalidate it explicitly.
  detail: (id: string) => ["staging-detail", id] as const,
};
